// TODO: após clonar o skeleton, ajustar os links de ambientes

const dev = {
	API_ENDPOINT_URL: "http://localhost:8080/bookids/api",
	PUBLIC_PREFIX_PATH: "",
	FRONT_ENDPOINT_URL: "http://localhost:3000",
};

const prod = {
	API_ENDPOINT_URL: "https://apolo.dimo.com.br/bookids/api",
	PUBLIC_PREFIX_PATH: "",
	FRONT_ENDPOINT_URL: "https://app.bookids.app.br",
};

const test = {
	API_ENDPOINT_URL: "https://homolog.dimo.com.br/bookids-back/api",
	PUBLIC_PREFIX_PATH: "/bookids",
	FRONT_ENDPOINT_URL: "https://homolog.dimo.com.br/bookids",
};

const getEnv = () => {
	switch (process.env.REACT_APP_ENV) {
		case "development":
			return dev;
		case "production":
			return prod;
		case "test":
			return test;
		default:
			return dev;
	}
};

export const env = getEnv();
